import { useQuery } from '@tanstack/react-query'
import { ticketRelatedQuery, type TicketRelatedRow } from '../api/easeedesk'
import { Spinner } from '../ui/Spinner'
import { NEW_TAB } from '../ui/NewTab'

/**
 * Fila "Related" - `easeedesk/tickets/details/history.php` cu constructorul
 * `TicketHistory` din `public/js/easeedesk/easeedesk.js`.
 *
 * Infatisarea e a portalului: `.ticket-history-container table` din
 * `public/css/app.css` (12px, cap ingrosat, rand cu linie dedesubt, randul
 * deschis pe fond roz) si `.history-devices` pentru titlul fiecarui grup - v4
 * incarca aceleasi foi, deci nu are nevoie de o foaie a lui.
 *
 * Cate un tabel de grup: intai ce a mai avut OMUL, apoi cate unul pentru fiecare
 * MASINA. Randurile nerezolvate sunt scoase in fata, si coloana din mijloc arata
 * starea cat timp tichetul e deschis, iar dupa aceea ziua in care s-a rezolvat.
 *
 * Randul duce la fisa tichetului din v4, in fila aceleiasi ferestre - in portal
 * se deschidea o fila noua de browser, fiindca acolo fisa era o pagina intreaga
 * incarcata de la zero.
 */

export function TicketRelated({ id }: { id: number }) {
  const { data, error } = useQuery(ticketRelatedQuery(id))

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {error.message}
      </div>
    )
  }
  if (!data) return <Spinner />

  if (data.groups.length === 0) {
    return (
      <div className="alert alert-info" role="alert">
        <i className="fas fa-info-circle"></i> There are no related tickets.
      </div>
    )
  }

  return (
    <div id={`rlTab${id}`} className="ticket-history-container">
      {data.groups.map((group) => (
        <div key={`${group.kind}-${group.name}`}>
          <div className="history-devices">
            <i className={group.kind === 'device' ? 'fas fa-desktop' : 'fa fa-user'} aria-hidden="true"></i> {group.kind === 'device' ? group.name : 'User history'}
          </div>

          <table>
            <thead>
              <tr>
                <td>Subject</td>
                <td>Created by</td>
                <td>Type</td>
                <td>Status/Resolved</td>
                <td>Assignee</td>
              </tr>
            </thead>
            <tbody>
              {group.tickets.map((row) => (
                <Row key={`${group.name}-${row.id}`} row={row} />
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  )
}

function Row({ row }: { row: TicketRelatedRow }) {
  /* `class="active"` pe celule, ca in portal: randul deschis se vede altfel. */
  const open = row.resolved === null
  const cell = open ? 'active' : undefined

  return (
    <tr className="clickable-row">
      <td className={cell}>
        <a href={`/app/easeedesk/ticket/${row.id}`} {...NEW_TAB}>{row.subject}</a>
      </td>
      <td className={cell}>{row.creator}</td>
      <td className={cell}>{row.type}</td>
      <td className={cell}>{open ? row.status : row.resolved}</td>
      <td className={cell}>{row.assignee}</td>
    </tr>
  )
}
